import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    TextInput, Button, FormGroup, ComposedModal, ModalHeader, ModalBody, ModalFooter, Toggle
} from 'carbon-components-react';
import SimpleReactValidator from 'simple-react-validator';
import { FindGHRSEmployer } from '../common/FindGHRSEmployer'
import { entitiesLabels } from '../../helpers/Constants';
import { showNotification } from '../../helpers/notification/BaseNotification';

export class TeamMemberModal extends Component {
    incidentTeamMemberModel = (props) => {

        if (props.isEditModal) {
            return { ...props.editModel };
        }

        return {
            id: null, //guid
            idIncident: null,//guid
            isTeamLeader: false,
            idEmployer: null,  //guid 
            name: null,
            surname:null ,
            email:null,
            ghrS_ID: null,
            employer: {
                id: null, //guid
                 name: '',
                 ghrS_ID: '',
                 surname: '',
                 email: '',
            },
            
        }
    }

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator({autoForceUpdate: this, locale: 'en'});
        this.state = {
            model: {
                ...this.incidentTeamMemberModel(props),
                  },
            mode: props.mode || 0,
        };
    }
    updateState = (inputName, inputValue, objName) => {
        let statusCopy = Object.assign({}, this.state);
        statusCopy[objName][inputName] = inputValue;

        this.setState(statusCopy);
    }
    handleChangeModel = (el) => {
        let inputName = el.target.name;
        let inputValue = el.target.value;
        let objName = el.target.alt;
        this.updateState(inputName, inputValue, objName);
    }

    handleToggle = (value, id) => {

        let statusCopy = Object.assign({}, this.state.model);
        statusCopy.isTeamLeader = value;

        this.setState({ model: statusCopy });
    }

    handleChangeMode = (m) => {
        this.setState({ mode: m })
    }

    setEmployer = (employer) => {
        
        if (employer && employer.id) {
            let statusCopy = Object.assign({}, this.state.model);
            statusCopy.idEmployer = employer.id;
            statusCopy.employer = employer;

            this.setState({ model: statusCopy, mode: 2 ,setEmployer: 1 });
        }
    }

    save = () => {
        if(this.state.model.idEmployer != null){
            this.props.save(this.state.model);}
        else{
        if (this.validator.allValid()) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(re.test(String(this.state.model.email).toLowerCase())){
        this.props.save(this.state.model);
        showNotification.success(`${entitiesLabels.SUCCESS}`,"Team Member created successfully");
        }else{
        showNotification.warning(`${entitiesLabels.WARNING}`,
          `${entitiesLabels.TEAMMEMBER} error email. `
        );
           
         } 
        }else {
            this.validator.showMessages();
            showNotification.warning(`${entitiesLabels.WARNING}`, entitiesLabels.TEAMMEMBER + " required fields are missing  ");
                this.forceUpdate();
             }
        }
    }

    render() {
        
        this.validator.purgeFields();
        const validations = {
            name: this.validator.message('name', this.state.model.name , 'required'),
            surname: this.validator.message('surname',this.state.model.surname, 'required'),
            email: this.validator.message('email', this.state.model.email , 'required|email'),
            
        }
        const modalHeader = {
            title: (this.props.isEditModal ? 'Edit ' : 'Add new '),
            iconDescription: 'Close',
            buttonOnClick: () => this.props.toggleModal(false)
        };
        const { title, isOpenModal } = this.props;


        const disabledTeamLeader = false;

        return (
            this.state.mode == 1 ?
                <FindGHRSEmployer isOpenModal={isOpenModal} onCancel={()=>this.props.toggleModal(false)} onOk={this.setEmployer} />
                :
                <ComposedModal
                    className="light-modal"
                    open={isOpenModal}
                    danger="false"
                    onClose={() => { return false; }}
                >
                    <ModalHeader className="margin-modal" {...modalHeader} ><p>{title || ''}</p></ModalHeader>
                    <ModalBody className="margin-modal">
                        {
                             this.state.mode == 0 ?
                             <div className="bx--row two-button-center modal--elemnts-buttons" >
                                 <Button kind="primary" className="bx--col-md-6" onClick={() => this.handleChangeMode(1)}>GHRS research</Button>
                                 <Button kind='primary' className="bx--col-md-6" onClick={() => this.handleChangeMode(2)}>Manual input</Button>
                             </div>
                             :
                            <div className="bx--grid--full-width">
                                <div className="bx--row">
                                {this.state.setEmployer === 1  ?
                                <FormGroup legendText="Team" className="bx--col-lg-6 bx--col-md-4">
                                        <Toggle
                                            id="isTeamLeader"
                                            aria-label=""
                                            labelText=""
                                            labelA="Team Member"
                                            labelB="Team Leader"
                                            toggled={this.state.model.isTeamLeader || false}
                                            disabled={disabledTeamLeader}
                                            onToggle={this.handleToggle} />
                                    </FormGroup>:"" }
                                    <FormGroup legendText="Name*" className="bx--col-md-4 bx--col-lg-6">
                                        <TextInput
                                            id="name"
                                            name="name"
                                            alt="model"
                                            placeholder="Input Name"
                                            value={this.state.model.name != null?  this.state.model.name : this.state.model.employer ? this.state.model.employer.name : ''}
                                             type="text"
                                            hideLabel={true}
                                            labelText=""
                                            disabled={this.state.model.idEmployer != null}
                                            onChange={this.handleChangeModel}
                                            invalid={validations.name != null}
                                            />
                                    {validations.name}
                                    </FormGroup>
                                    <FormGroup legendText="Surname*" className="bx--col-md-4 bx--col-lg-6">
                                        <TextInput
                                            id="txt-surname"
                                            name="surname"
                                            alt="model"
                                            placeholder="Input Surname"
                                            value={  this.state.model.surname ?   this.state.model.surname: this.state.model.employer ? this.state.model.employer.surname :'' }
                                            type="text"
                                            hideLabel={true}
                                            labelText=""
                                            disabled={this.state.model.idEmployer != null}
                                            onChange={this.handleChangeModel}
                                            invalid={validations.surname != null}
                                            />
                                    {validations.surname}
                                    </FormGroup>
                                    <FormGroup legendText="Badge Number" className="bx--col-md-4 bx--col-lg-6">
                                        <TextInput
                                            id="txt-badgeNumber"
                                            name="ghrS_ID"
                                            alt="model"
                                            placeholder=""
                                            value={this.state.model.ghrS_ID ?   this.state.model.ghrS_ID: this.state.model.employer ? this.state.model.employer.ghrS_ID : '' }
                                            type="text"
                                            hideLabel={true}
                                            labelText=""
                                            disabled={this.state.model.idEmployer != null}
                                            onChange={this.handleChangeModel}
                                        />
                                    </FormGroup>
                                    <FormGroup legendText="Email* (Personal Email Addresses are not allowed)" className="bx--col-md-4 bx--col-lg-6">
                                        <TextInput
                                            id="txt-email"
                                            name="email"
                                            alt="model"
                                            placeholder="Input Email"
                                            value={this.state.model.email ?   this.state.model.email :  this.state.model.employer ? this.state.model.employer.email : ''  }
                                            type="text"
                                            hideLabel={true}
                                            labelText=""
                                            disabled={this.state.model.idEmployer != null}
                                            onChange={this.handleChangeModel}
                                            invalid={validations.email != null}
                                            title="&#9888; Do Not use Personal Accounts"
                                            />
                                    {validations.email}
                                    </FormGroup>

                                </div>
                            </div>
                        }
                    </ModalBody>
                    <ModalFooter >
                        <Button kind="secondary" onClick={() => this.props.toggleModal(false)}>Cancel</Button>
                        <Button kind='primary' onClick={() => this.save()}>Save</Button>
                    </ModalFooter>
                </ComposedModal>
        );
    }
}

TeamMemberModal.propTypes = {
    save: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
    isEditModal: PropTypes.bool,
    isOpenModal: PropTypes.bool,
    mode: PropTypes.number,
    title: PropTypes.string,
};